import React, { useState, useRef, useEffect } from "react";
import { LuSettings2 } from "react-icons/lu";
import { Checkbox } from "../form/inputs";

const FILTER_OPTIONS = [
  { label: "All", value: "all" },
  { label: "All subscribers", value: "active" },
  { label: "Inactive Subscribers", value: "inactive" },
  { label: "Bill Due", value: "bill_due" },
];

const FilterPopover = ({ onApply, activeTab }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("all");
  const ref = useRef(null);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ SIMPLE CONDITION
  const visibleFilters =
    activeTab === "active_plan_customer"
      ? FILTER_OPTIONS.filter(
          (item) => item.value === "all" || item.value === "bill_due",
        )
      : FILTER_OPTIONS;

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className={`border rounded-md p-[13px] transition-all ${
          selected !== "all"
            ? "bg-red-50 text-red-500 border-red-200"
            : "bg-white text-gray-600 border-gray-200"
        }`}
      >
        <LuSettings2 size={18} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-4 space-y-3">
            <p className="font-medium">Filter</p>

            {visibleFilters.map((item) => (
              <label
                key={item.value}
                className="flex gap-2 items-center cursor-pointer"
              >
                <Checkbox
                  checked={selected === item.value}
                  onChange={() => setSelected(item.value)}
                />
                <p className="text-sm text-gray-700">{item.label}</p>
              </label>
            ))}

            <div className="flex gap-3 pt-2">
              <button
                onClick={() => setOpen(false)}
                className="px-3 py-1 text-sm border border-[#FB6742] rounded-full text-[#FB6742]"
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  onApply?.(selected);
                  setOpen(false);
                }}
                className="px-3 py-1 text-sm bg-[#FB6742] rounded-full text-white"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterPopover;
